<div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12 fullheight">
    <div class="main-content">
        <div class="clear20"></div>
        <div class="col-sm-7 col-md-7 col-lg-12 col-xl-12 col-12">
            <div class="" *ngIf="isCompletedOT">
                <h6 class="txt-black regular lh">Thank you for completing the required training. To complete your sign-up, please proceed to "Sign Agreement".</h6>
            </div>
            <!-- <div *ngIf="contractCard && isUploaddoc">
            <div class="card cardbox" >
                <div class="card-body" >
                    <h6 class="txt-black regular lh">Your signed Agreement are sent for verification and counter sign. Once approved your onboarding will be completed. Meanwhile you can <span class="bold">take the Broker Online Training.</span></h6>
                 
                </div>     
            </div>    
            <div class="clear40"></div>
                 <button type="button" class="btn btn-blue" (click)="showCard()">Start Online Training <span class="float-right"><img src="./assets/images/rightarrow.png" /></span></button>
          </div> -->

            <!-- <div *ngIf="!isUploaddoc">
            <div class="card cardbox" >
                <div class="card-body" >
                    <h6 class="txt-black regular lh">
                        You can proceed further only after uploading all the required
                            documents.
                        </h6>
                 
                </div>     
            </div>    
            <div class="clear40"></div>
                 
          </div> -->

            <!-- <div *ngIf="!contractCard"> -->
            <div>
                <div class="alert alert-black fixed-bottom ml-auto mb-0 pad5">
                    <div class="row">
                        <div class="col-sm-9 col-md-9 col-lg-9 col-xl-9 col-12 " *ngIf="isInprogressOT">
                            <h6 class="fs-18 txt-grey regular mt-2">Click 'Proceed' to begin the required training module. Clicking 'Proceed' will open the online training in a new window. If a new window does not open, please set your pop-up settings to allow pop-ups.</h6>
                        </div>
                        <div class="col-sm-9 col-md-9 col-lg-9 col-xl-9 col-12 " *ngIf="isCompletedSA && isCompletedOT">
                            <h6 class="fs-18 txt-grey regular mt-2">Thank you for your submission. Your signed agreement is being reviewed. Once approved, you will receive an email notifying you that the sign-up process is complete and you will be able to access our online sales portal through
                                MyTL. Please allow 5 business days. If you have any questions, please email <a href="mailto:join@travelance.ca">join@travelance.ca</a>.</h6>
                        </div>

                        <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3 col-12 ml-auto">
                            <button type="button"  *ngIf="isCompletedOT==false" class="btn btn-blue" (click)="authorizeUser()">Proceed <img src="./assets/images/btn-arrow.png" class="float-right" /></button>
                            <button type="button" *ngIf="isCompletedOT" class="btn btn-blue" (click)="authorizeUser()">Return to Training <img src="./assets/images/btn-arrow.png" class="float-right" /></button>
                        </div>

                        <!-- <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 "> 
                        <button type="button" class="btn btn-green" (click)="goToGetReliable()">Proceed To Get-Reliable <img
                                src="./assets/images/btn-arrow.png" class="float-right" /></button>
                    </div>  -->

                    </div>
                </div>
            </div>

        </div>
    </div>


</div>